import Table from "components/Table";
import { useMemo, useEffect } from "react";
import { useMap } from "context/mapContext";
import { useLoading, handleLoading } from "context/LoadingContext";
import getEsriDataFromLayer from "context/contextFunctions/getEsriDataFromLayer";
import RemovedUnitsReportFilter from "./RemovedUnitsReportFilter";

const neededDomains = [
  "Is_Installed",
  "Category",
  "Action_to_be_taken",
  "Removed_Unit_Type",
  "Removed_Unit_Capacity",
];

export default function RemovedUnitsReport() {
  const [map, dispatchMap] = useMap();
  const [, dispatchLoading] = useLoading();
  const { view, unitsTable, removedUnits } = map;

  const headers = useMemo(
    () => [
      {
        accessorKey: "Removed_Unit_Type",
        header: "Removed Unit Type",
        enableColumnFilter: false,
      },
      {
        accessorKey: "Removed_Unit_Capacity",
        header: "Removed Unit Capacity",
        enableColumnFilter: false,
      },
      {
        accessorKey: "Unit_Prod_ID",
        header: "New Unit ID",
        enableColumnFilter: false,
      },
      {
        accessorKey: "Pole_ID",
        header: "Pole ID",
        enableColumnFilter: false,
      },
      {
        accessorKey: "CategoryName",
        header: "New Unit Category",
        enableColumnFilter: false,
      },
      {
        accessorKey: "Governorate",
        header: "Governorate",
        enableColumnFilter: false,
      },
      {
        accessorKey: "Municipality",
        header: "Municipality",
        enableColumnFilter: false,
      },
      {
        accessorKey: "X",
        header: "X",
        enableColumnFilter: false,
        cell: (param) => param.cell.row.original.X,
      },
      {
        accessorKey: "Y",
        header: "Y",
        enableColumnFilter: false,
        cell: (param) => param.cell.row.original.Y,
      },
      {
        accessorKey: "Installation_Date",
        header: "Replacement Date",
        enableColumnFilter: false,
        cell: (param) => param.cell.row.original.Installation_Date_ISO,
      },
    ],
    []
  );

  const exportHeaders = useMemo(
    () => [
      {
        key: "Removed_Unit_Type",
        label: "Removed Unit Type",
      },
      {
        key: "Removed_Unit_Capacity",
        label: "Removed Unit Capacity",
      },
      {
        key: "Unit_Prod_ID",
        label: "New Unit ID",
      },
      {
        key: "Pole_ID",
        label: "Pole ID",
      },
      {
        key: "CategoryName",
        label: "New Unit Category",
      },
      {
        key: "Governorate",
        label: "Governorate",
      },
      {
        key: "Municipality",
        label: "Municipality",
      },
      {
        key: "X",
        label: "X",
      },
      {
        key: "Y",
        label: "Y",
      },
      {
        key: "Installation_Date_ISO",
        label: "Replacement Date",
      },
    ],
    []
  );

  useEffect(() => {
    (async () => {
      handleLoading(dispatchLoading, true);
      try {
        const token = localStorage.getItem("token");
        const query =
          "Removed_Unit_Type IS NOT NULL AND Removed_Unit_Capacity IS NOT NULL";
        const orderByFields = ["Installation_Date DESC"];
        if (unitsTable && view && token) {
          const {
            res: unitsRes,
            domains: removedUnitsDomains,
            fields: removedUnitsFields,
          } = await getEsriDataFromLayer({
            featureLayer: unitsTable,
            orderByFields,
            neededDomains,
            returnGeometry: true,
            view,
            query,
          });

          dispatchMap({
            type: "INIT",
            payload: {
              removedUnitsDomains,
              removedUnitsFields,
              removedUnits: unitsRes,
            },
          });
        }
      } catch (error) {
        console.log(error);
      }
      handleLoading(dispatchLoading, false);
    })();
  }, [view, unitsTable]);

  return (
    <div>
      <RemovedUnitsReportFilter />
      <Table
        columns={headers}
        data={removedUnits}
        exportName={`Units-Report-${new Date().toISOString().split("T")[0]}`}
        exportColumns={exportHeaders}
      />
    </div>
  );
}
